/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ApiCredentialsProperties } from '../models/ApiCredentialsProperties';

export class CreateApiCredentialsResponse {
  'apiCredentialsProperties': ApiCredentialsProperties;
  /**
  * The secret of the api credentials
  */
  'clientSecret': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "apiCredentialsProperties",
      "baseName": "apiCredentialsProperties",
      "type": "ApiCredentialsProperties",
      "format": ""
    },
    {
      "name": "clientSecret",
      "baseName": "clientSecret",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateApiCredentialsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

